import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Column from "@components/Grid/Column";
import { WEALTH_CARD_VARIANTS } from "@pages/Section/layouts/Wealth/utils/constant";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

type WealthWatchesProps = {
  /** Optional className for the component */
  className?: string;
  /** The card props for the wealth watches component */
  cardProps: ComponentProps<typeof Card>[];
};

/**
 * The wealth watches component for the wealth page.
 * NO FIGMA LINK
 * */
const WealthWatches = ({
  cardProps,
  className,
}: WealthWatchesProps): React.ReactElement => {
  return (
    <div
      data-testid="wealth-watches-component"
      className={cn("border-t border-black pt-3", className)}
    >
      <BlockTitle
        text="WATCHES"
        link="/keywords/watches"
        rootClassName="mb-3"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          {cardProps.map((cardProp) => {
            return (
              <Card
                key={cardProp.id}
                {...cardProp}
                variations={WEALTH_CARD_VARIANTS.watches}
                className="items-stretch"
              />
            );
          })}
        </div>

        <Ad
          adType="imu3"
          className="flex flex-col items-center justify-center lg:sticky lg:top-[70px]"
        />
      </div>

      <Column rootClassName="pb-6 w-full lg:w-4/12"></Column>
    </div>
  );
};

export default WealthWatches;
